/**
 * AT1 Feedback Modal
 *
 * Modal de feedback permettant à l'agent d'ajouter un commentaire optionnel
 * après avoir cliqué sur 👍 ou 👎 dans la bannière.
 */

/**
 * ============================================================================
 * AB TEST: Maturity AT1 Feedback Experiment (ab_at1_feedback)
 * PR: #2501
 *
 * This file is part of an A/B test experiment for collecting user feedback
 * on automatically generated AT1 messages. When the experiment concludes,
 * this entire file should be either:
 * - Removed if the experiment is unsuccessful
 * - Renamed (remove AB_ prefix) and integrated permanently if successful
 *
 * To find all AB test code: grep -r "ab_at1_feedback" src/
 * ============================================================================
 */

import { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

interface Props {
    open: boolean;
    feedbackValue: 1 | 0 | null;
    onClose: (comment?: string) => void;
}

export const AT1FeedbackModal = ({ open, feedbackValue: _feedbackValue, onClose }: Props) => {
    const [comment, setComment] = useState('');
    const { formatMessage } = useIntl();

    const handleSubmit = () => {
        onClose(comment.trim() || undefined);
        setComment('');
    };

    return (
        <Dialog open={open} onClose={handleSubmit} fullWidth maxWidth="sm">
            <DialogTitle sx={{ typography: 'h2' }}>
                {formatMessage({ id: 'discussion.at1_feedback.modal.title' })}
            </DialogTitle>
            <DialogContent>
                <TextField
                    multiline
                    rows={4}
                    fullWidth
                    placeholder={formatMessage({ id: 'discussion.at1_feedback.modal.placeholder' })}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleSubmit}>
                    {formatMessage({ id: 'discussion.at1_feedback.modal.submit' })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
